// extracted by mini-css-extract-plugin
export default {"wrapper":"Buttons_wrapper__YeZA2","terminalButtons":"Buttons_terminalButtons__mlwmO","value":"Buttons_value__Ht1p6"};